import SiteLayout from '@/components/feature/SiteLayout';
import HeroSlider from '@/pages/home/components/HeroSlider';
import WelcomeSection from '@/pages/home/components/WelcomeSection';
import CategorySection from '@/pages/home/components/CategorySection';
import NetworkSection from '@/pages/home/components/NetworkSection';
import DistributorSection from '@/pages/home/components/DistributorSection';
import DistributorFormSection from '@/pages/home/components/DistributorFormSection';

export default function Home() {
  return (
    <SiteLayout>
      <HeroSlider />
      <WelcomeSection />
      <CategorySection />
      <NetworkSection />
      <DistributorSection />
      <DistributorFormSection />
    </SiteLayout>
  );
}